import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useQueryParam } from 'builder/hooks/useQueryParam'
import Spinner from 'builder/components/Spinner'
import { baseClient } from 'builder/modules/apiClient'
import { RecommendAlertResponse } from 'builder/modules/jobSearch/types'
import { useMutationMagicAuth } from './hooks/useMutationMagicAuth'
import { SpinnerContainer } from './styles'

export const MagicLinkAuthAndRedirectJobAlert = () => {
  const [token] = useQueryParam('magic-link-token')
  const mutationMagicAuth = useMutationMagicAuth()
  const navigate = useNavigate()
  const params = useParams()

  useEffect(() => {
    async function requestMagicLink() {
      if (token) {
        try {
          await mutationMagicAuth.mutateAsync({ token })
        } catch (error) {
          console.warn('Invalid token or expired token')
        }
      }
      const pathSegments = (params['*'] || '').split('/').filter(Boolean)
      const path = pathSegments[0]
      let subscriptionId = 'no-subscription'
      let externalSlugId = null

      if (pathSegments.length === 3) {
        subscriptionId = pathSegments[1]
        externalSlugId = pathSegments[2]
      } else if (pathSegments.length === 2) {
        externalSlugId = pathSegments[1]
        if (path === 'recommend-alert') {
          let response = await baseClient.get<RecommendAlertResponse>(
            '/job-alerts/v1/recommendation-subscription',
          )
          if (response.data.id !== undefined) {
            subscriptionId = String(response.data.id)
          }
        }
      }
      navigate(`/email/job-search/${path}/${subscriptionId}/${externalSlugId}`)
    }
    requestMagicLink()
  }, [token, params])

  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  )
}
